const { replaceKeys, isSet, isNotSet } = require('@/js/utils.js');
const { Genv } = require('@/js/global.js');

class CheckObject {
    constructor() {
        this.formValues = {}
        this.setData = {}
    }

    checkFieldSync(field, valid, fieldConf, formValues) {
        // eslint-disable-next-line 
        //debugger;
        this.formValues = formValues;
        this.setData = {}
        var status = { status: true };
        var value = this.formValues[field];
        console.log("check:" + field + " = " + value + " type:" + valid.type)
        try {
            value = this.parseValue(fieldConf.type, this.formValues[field]);
        } catch (e) {
            return { status: false, msg: e.message || "Error en asignacion" }
        }
        const valueCompare = (isSet(valid.valueVs)) ? valid.valueVs : ((isSet(valid.compareWith)) ? this.formValues[valid.compareWith] : null);
        const valueVs = this.parseValue(fieldConf.type, valueCompare);

        if (fieldConf.required && isNotSet(value)) return { status: false, errorMessage: "required" }
        if (!valid) return { "status": true, "errorMessage": "", "setData": this.setData };
        status = this.checkLength(value, valid);
        if (status.status === false) return status;
        if (!valid.type) valid.type = 'fieldValue';
        switch (valid.type) {
            case 'fieldValue':
                {
                    const value = this.formValues[valid.field];
                    if ((typeof value == "undefined") || !this.compareValue(value, valid.value, valid.signo)) {
                        status = { status: false, "msg": valid.msg };
                    }
                    break;
                }
            case 'compare':
                {
                    const signo = (isSet(valid.signo)) ? valid.signo : ((isSet(valid.comparisonType)) ? valid.comparisonType : "==")
                    if (!this.compareValue(value, valueVs, signo)) {
                        console.log("compare:" + value + " vs " + valueVs + " " + signo, this.formValues)
                        status = { status: false, "msg": valid.msg };
                    }
                    break;
                }
            case 'isEmail':
                {
                    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) status = { "status": false, "msg": valid.msg };
                    break;
                }
            case 'isPhone':
                {
                    if (!/^\+?[0-9]+$/.test(value)) status = { "status": false, "msg": valid.msg };
                    break
                }
            case 'isNumeric':
                {
                    if (!(/^\d+$/.test(String(value)))) {
                        status = { "status": false, "msg": valid.msg };
                    }
                    break;
                }
            case 'pattern':
                if (!valid.pattern.test(value)) status = { "status": false, "msg": valid.msg };
                break;
            case 'dateComparison':
                {
                    const days = valid.days || 0;
                    if (isSet(days) && days != 0) {
                        const adjustedDate = new Date(this.formValues[field]);
                        adjustedDate.setDate(adjustedDate.getDate() + days);
                        value = adjustedDate;
                    }
                    if (valueVs > value) {
                        status = { status: false, "msg": valid.msg };
                    }
                    break;
                }

        }
        if (status.status === false) {
            console.log("Error check:" + field + " = " + value + " type:" + valid.type + " " + status.msg)
            const errorMessage = (status.msg) ? status.msg : (valid.msg) ? valid.msg : "error";
            return { status: false, msg: errorMessage }
        }
        return status;

    }

    parseValue(type, value) {
        if (type === "datetime-local") {
            return new Date(value);
        } else if (type === "date") {
            return new Date(value + "T00:00:00");
        }
        return value
    }


    async checkField(field, valid, fieldConf, formValues) {
        const status = this.checkFieldSync(field, valid, fieldConf, formValues);
        if (status.status === false) return status;
        const value = this.parseValue(fieldConf.type, this.formValues[field]);

        if (valid.set) {
            let swValid = true;
            if (!(await this.validSet(valid.set, field, value))) swValid = false;
            if (!swValid) return { status: false, msg: "error en asignacion" };
        }
        this.setData[field] = value;
        if (valid.emit) this.$eventBus.emit(valid.emit, field, value); /* emit evento con datos del campo para interceptar su entrada si es necesario en la logica */
        return { "status": true, "msg": "", "setData": this.setData };
    }
    checkLength(value, valid) {
        if (!valid.minLength && !valid.maxLength) return { status: true, "msg": "" };
        if (String(value).length < valid.minLength || String(value).length > valid.maxLength) {
            return { status: false, "msg": valid.msg };
        }
        return { status: true, "msg": "" };
    }
    compareValue(val1, val2, signo = "==") {
        switch (signo) {
            case '>':
                return val1 > val2;
            case '<':
                return val1 < val2;
            case '=':
            case '==':
                return val1 == val2;
            case '>=':
                return val1 >= val2;
            case '<=':
                return val1 <= val2;
            case '!=':
                return val1 != val2;
            default:
                return false;
        }
    }
    async validSet(validField, field, value) {
        let swValid = true;

        console.log("validSet:", field, validField)
        const formValues = {...this.formValues, [field]: value }
        for (let fSet in validField) {
            const valid = validField[fSet]
            const keyValue = (valid.keyDB) ? replaceKeys(valid.keyDB, formValues) : formValues[field];
            let data = {}
            if (valid.collection) {
                // eslint-disable-next-line 
                data = await Genv.fsCia.collection(valid.collection).doc(keyValue).get()
                if (!data) { swValid = false; continue; }
            }
            if (valid.action) {
                const apiData = Genv.$prepareApiData(this.checkNestedValues(formValues))
                const st = await Genv.$api.call(valid.action, apiData);
                if (!st.status) { swValid = false; continue; }
                data = {...data, ...st.data };
            }
            if (isNotSet(data[fSet])) data[fSet] = (isSet(this.setData[fSet])) ? this.setData[fSet] : "";
            this.setData = {...this.setData, ...data }
        }
        return swValid;
    }
    checkNestedValues(obj) {
        // eslint-disable-next-line 
        //debugger;
        const hasNestedKeys = Object.keys(obj).some(key => key.includes('@'));
        if (!hasNestedKeys) return obj;
        const result = {};

        for (const key in obj) {
            const [key2, dominio] = key.split("@");
            if (dominio) {
                if (result[dominio]) result[dominio][key2] = obj[key]
                else result[dominio] = {
                    [key2]: obj[key]
                }
            } else result[key2] = obj[key]
        }

        return result;
    }

}
const objCheck = new CheckObject();

module.exports = {
    checkField: objCheck.checkField.bind(objCheck),
    checkFieldSync: objCheck.checkFieldSync.bind(objCheck),
    checkNestedValues: objCheck.checkNestedValues.bind(objCheck),
};